import { SiteData } from "./interfaces";

export const defaultSiteData : SiteData = {
    Header: {
        title: '',
        paragraph: ''
      },
      About: {
        paragraph: '',
        Why: [],
        Why2: []
      },
      AboutProjects: {
        paragraph: '',
        Why: [],
        Why2: []
      },
      Projects: [],
      Services: [],
      Testimonials: [],
      Team: [],
      Contact: {
        address: '',
        phone: '',
        email: '',
        linkedIn: '',
        instagram: ''
      },
      Features: [],
      Apply: {
        students: {
          title: "",
          description: "",
          buttonText: "",
          link: "",
          image: ""
        },
        roles: [
          {
              title: "",
              description: "",
              buttonText: "",
              link: ""
          }
      ]
  }
}